import axios from 'axios'

const configuredBaseURL = process.env.VUE_APP_IRIS_API_URL_DEV_PROD || '/api'
const useSameOriginProxy = process.env.VUE_APP_USE_LOCAL_API_PROXY === 'true'
const baseURL = useSameOriginProxy ? '/api' : configuredBaseURL

const http = axios.create({
  baseURL
})

http.interceptors.request.use(request => {
  const baseURL = request.baseURL || http.defaults.baseURL
  const url = request.url

  if (baseURL && url) {
    const isAbsolute = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(url)
    const isProtocolRelative = /^\/\//.test(url)

    if (isAbsolute || isProtocolRelative) {
      try {
        const origin = (typeof window !== 'undefined' && window.location && window.location.origin)
          ? window.location.origin
          : 'http://localhost'
        const baseUrlObj = new URL(baseURL, origin)
        const requestUrlObj = new URL(url, baseUrlObj)
        const baseHref = baseUrlObj.href.endsWith('/')
          ? baseUrlObj.href
          : baseUrlObj.href + '/'

        if (!(requestUrlObj.href === baseUrlObj.href || requestUrlObj.href.startsWith(baseHref))) {
          const error = new Error('Blocked absolute URL that does not match baseURL.')
          error.code = 'ERR_BASEURL_MISMATCH'
          return Promise.reject(error)
        }
      } catch {
        const error = new Error('Blocked malformed URL before request.')
        error.code = 'ERR_MALFORMED_URL'
        return Promise.reject(error)
      }
    }
  }

  return request
})

export const setAuthToken = token => {
  if (token) {
    http.defaults.headers.common.Authorization = token
  } else {
    delete http.defaults.headers.common.Authorization
  }
}

export default http
